module.exports = __webpack_public_path__ + "assets/img/news-item.0ff9509a.png";